import {Stack, useMediaQuery} from '@mui/material'
import React from 'react'
import ContributionsChartJS from './ContributionsChartJS'
import TotalAppContributions from './TotalAppContributions'
import TotalCommunes from './TotalCommunes'
import TotalContributions from './TotalContributions'
import TotalProducers from './TotalProducers'
import TotalProduits from './TotalProduits'
import TotalStores from './TotalStores'
import TotalTerroirs from './TotalTerroirs'
import UsersChartJS from './UsersChartJS'

import Welcome from './Welcome'


const Dashboard = () => {
	const isWide = useMediaQuery('(min-width:1024px)')

	const styles = {
		flex: {display: 'flex', gap: '20px', flexFlow: isWide ? 'initial' : 'column'},
		flexColumn: {display: 'flex', flexDirection: 'column'},
		leftCol: {flex: 1, marginRight: '0.5em'},
		rightCol: {flex: 1, width: '-webkit-fill-available'},
		singleCol: {marginTop: '1em', marginBottom: '1em'}
	}
	return (
		<>
			<Welcome/>
			<Stack spacing={2} mb={2}>
				{/* Première ligne - Statistiques principales */}
				<Stack direction="row" spacing={2}>
					<TotalTerroirs/>
					<TotalCommunes/>
					<TotalProduits/>
					<TotalProducers/>
					<TotalStores/>
					{/*<TotalTags/>*/}
				</Stack>

				{/* Deuxième ligne - Producteurs et contributions */}
				<Stack direction="row" spacing={2}>
					<ContributionsChartJS/>
					<UsersChartJS/>
					{/*<ProducerStats/>*/}
				</Stack>

				{/* Troisième ligne - Contributions avec graphiques */}
				<Stack direction="row" spacing={2}>
					{/*<ContributionsRecharts/>*/}
					<TotalAppContributions/>
				</Stack>
				<Stack direction="row" spacing={2}>
					<TotalContributions/>
				</Stack>
			</Stack>
		</>
	)
}

export default Dashboard
